<template>
    <VSelect :placeholder="$t('CountrySelect.selectCountry')" :options="countries" label="name"
             :value="selectedCountry" @input="setSelectedCountry" :clearable="clearable" :filter-by="filterBy">
        <template slot="option" slot-scope="option">
            <img class="mr-1" alt="flag" width="15" :src="getDiceBaseUrl() + option.flagURL"/>
            <span v-html="option.name"/>
        </template>
        <template v-if="required" slot="search" slot-scope="{ attributes, events }">
            <input class="vs__search" :required="!selectedCountryAlpha3" v-bind="attributes" v-on="events"/>
        </template>
    </VSelect>
</template>

<script>
import { mapGetters } from "vuex";
import { filterBy } from "../../../helpers/VSelect";

export default {
    name: "CountrySelect",
    props: {
        selectedCountryAlpha3: {
            required: true,
        },
        required: {
            type: Boolean,
            default: true,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters("countries", {
            countries: "countries",
        }),
        selectedCountry() {
            return this.countries ? this.countries.find(country => country.alpha3ISO === this.selectedCountryAlpha3) : null;
        },
    },
    methods: {
        setSelectedCountry(country) {
            this.$emit("setSelectedCountry", country);
        },
        filterBy,
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>